/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Individual user provision result
 * @export
 * @interface UserProvisionResult
 */
export interface UserProvisionResult {
    /**
     * User email
     * @type {string}
     * @memberof UserProvisionResult
     */
    email?: string;
    /**
     * Whether this user was successfully provisioned
     * @type {boolean}
     * @memberof UserProvisionResult
     */
    success?: boolean;
    /**
     * User ID if successfully created
     * @type {string}
     * @memberof UserProvisionResult
     */
    userId?: string;
    /**
     * Error message if provisioning failed
     * @type {string}
     * @memberof UserProvisionResult
     */
    error?: string;
    /**
     * Status: CREATED, SKIPPED, or FAILED
     * @type {string}
     * @memberof UserProvisionResult
     */
    status?: string;
}

/**
 * Check if a given object implements the UserProvisionResult interface.
 */
export function instanceOfUserProvisionResult(value: object): value is UserProvisionResult {
    return true;
}

export function UserProvisionResultFromJSON(json: any): UserProvisionResult {
    return UserProvisionResultFromJSONTyped(json, false);
}

export function UserProvisionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProvisionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'success': json['success'] == null ? undefined : json['success'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'error': json['error'] == null ? undefined : json['error'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function UserProvisionResultToJSON(json: any): UserProvisionResult {
    return UserProvisionResultToJSONTyped(json, false);
}

export function UserProvisionResultToJSONTyped(value?: UserProvisionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'success': value['success'],
        'userId': value['userId'],
        'error': value['error'],
        'status': value['status'],
    };
}

